module.exports = __webpack_public_path__ + "static/media/inner-speaker.97bc32f3.jpg";